/*
 *
 * AnalyticsPage
 *
 */

import React from "react";
import Helmet from "react-helmet";
import { RouteSubRoutes } from "routes";
import { Wrapper } from "./styledComponents";

class AnalyticsPage extends React.PureComponent {
  render() {
    const { routes } = this.props;
    return (
      <Wrapper>
        <Helmet title="Movebooth | Analytics" />
        <div className="analytics-page__content">
          {routes.map((r, i) => (
            <RouteSubRoutes key={i} {...r} />
          ))}
        </div>
      </Wrapper>
    );
  }
}

export default AnalyticsPage;



// WEBPACK FOOTER //
// ./src/containers/AnalyticsPage/index.js